<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full md:w-[70%] xl:w-[50%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Viewing Posting Order
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div
          class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
        >
          <div
            class="flex flex-col md:flex-row md:items-center gap-[10px] w-full"
          >
            <p class="text-[20px] font-bold text-[#2463EB] leading-[20px]">
              Payment # {{ data.owner.code }}
            </p>
            <span
              :class="[
                'max-w-max',
                'badge',
                ' badge-pill',
                {
                  'badge-warning':
                    data.paymentStatus == 'PENDING AUTHORIZATION',
                },
                { 'badge-danger': data.paymentStatus == 'REVERSED' },
                { 'badge-success': data.paymentStatus == 'AUTHORIZED' },
              ]"
              >{{
                data.paymentStatus === "AUTHORIZED"
                  ? "COMPLETED"
                  : data.paymentStatus
              }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Amount
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ formatMoney(data.paidAmount) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Customer
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{
                data.owner.displayName ? data.owner.displayName : "***"
              }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Account ID
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ data.owner.code }}</span
            >
          </div>
          <div class="py-[24px]">
            <hr />
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Reference ID
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ data.referenceId }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Channel
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ prepareDetail(data.paymentChannel) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Fees
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ data.fees ? data.fees : "***" }}</span
            >
          </div>
          <div class="py-[24px]">
            <hr />
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Posting Date
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ formatDate(data.paidOn) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Completed Date
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ formatDate(data.created) }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Entry Date
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{ formatDate(data.created) }}</span
            >
          </div>
          <div class="py-[24px]">
            <hr />
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Created By
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
              >{{
                data.maker.displayName ? data.maker.displayName : "***"
              }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
            >
              Authorized By
            </h2>
            <span
              class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
            >
              {{
                data && data.authorizedBy && data.authorizedBy.displayName
                  ? data.authorizedBy.displayName
                  : "***"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
export default {
  props: ["data", "closeModal"],

  methods: {
    prepareDetail(value) {
      const name = value ? value.paymentChannelTypeName : null;
      let result = "";
      if (name) {
        result += name;

        if (name.toLowerCase() === "bank") {
          result += "/ " + value.bankName + "/ " + value.accountNumber;
        } else if (name.toLowerCase() === "pos") {
          result += "/ " + value.bankName + "/ " + value.terminalId;
        } else if (name.toLowerCase() === "cryptocurrency") {
          result += "/ " + value.bankName + "/ " + value.walletAddress;
        }
      }
      return result;
    },

    formatDate(date) {
      if (date) return moment(date).format("ll");
      else return "";
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },
  },
};
</script>
